<template>
  <div class="setting">
    <div class="cover" @click="toggleSetting" v-bind:class="{ opened: settingEnabled }">
      <span class="setting-title">{{title}}</span>
      <span class="setting-toggle">
        <img src="/images/svg/global/arrow-right-r.svg" v-if="!settingEnabled"/>
        <img src="/images/svg/global/arrow-down.svg" v-if="settingEnabled" v-bind:class="{ opened: settingEnabled }"/>
      </span>
    </div>
    <div class="setting-content" v-bind:class="{ opened: settingEnabled }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'CustomOption',
    components: {},
    props:['title', 'doClose'],
    computed: {
      ...mapGetters(['_T']),
    },
    watch:{
      doClose: function(new_value) {
        if (new_value !== this.title) {
          this.settingEnabled = false
        }
      }
    },
    methods: {
      toggleSetting() {
        this.settingEnabled = !this.settingEnabled
        this.$emit('closeAll', this.title)
      }
    },
    mounted() {
    },
    data() {
      return {
        settingEnabled: false,
      }
    }
  }
</script>

<style lang="scss" scoped>

  @keyframes openDown {from {height: 0px;}to {height: auto;}}

  @keyframes openUp {from {height: auto;}to {height: 0px;}}

  .setting {
    border-bottom: 1px solid gray;
    .setting-toggle {
      padding-right: 0.5rem;
      float: right;
      img {
        width: 10px;
        height: 10px;
      }

    }
    .cover{
      cursor: pointer;
      &.opened{
        font-weight: bold;
      }
      .setting-title {
        padding-left: 0.5rem;
        cursor: pointer;
      }
    }
    .setting-content{
      margin: 0.5rem;
      max-height: 0;
      overflow: hidden;
      -webkit-transition: max-height .35s;
      -o-transition: max-height .35s;
      transition: max-height .35s;
      &.opened{
        max-height: 100vh;
      }
    }
  }

</style>
